import React, { ReactNode } from 'react';
import { Layout } from 'antd';

import styles from './OnboardingLayout.module.less';

const { Content } = Layout;

type Props = {
  children: ReactNode;
};

export default function OnboardingLayout(props: Props) {
  const { children } = props;

  return (
    <Layout>
      <Content className={styles.content}>{children}</Content>
    </Layout>
  );
}
